import { useQuery } from '@apollo/client';

import {
  GetCompanyQuery,
  GetSyncedProvidersQuery,
  GetSyncedProvidersQueryVariables,
  GET_SYNCED_PROVIDERS,
} from '../graphql';
import { useCurrentCompany } from './useCurrentCompany';

export const useProviderTokensAndSyncedProviders = ({
  fiscalYearId,
}: {
  fiscalYearId: string;
}): {
  accountingTokens?: GetCompanyQuery['getCompany']['accountingTokens'];
  payrollTokens?: GetCompanyQuery['getCompany']['payrollTokens'];
  ticketingTokens?: GetCompanyQuery['getCompany']['ticketingTokens'];
  loading: boolean;
  startPolling: (pollInterval: number) => void;
  stopPolling: () => void;
  syncedProviders?: GetSyncedProvidersQuery['getFiscalYear']['syncedProviders'];
} => {
  const {
    data: syncedProviderData,
    loading: syncedProvidersLoading,
    startPolling: startPollingSyncedProviders,
    stopPolling: stopPollingSyncedProviders,
  } = useQuery<GetSyncedProvidersQuery, GetSyncedProvidersQueryVariables>(GET_SYNCED_PROVIDERS, {
    variables: {
      fiscalYearId,
    },
  });

  const {
    company,
    loading: companyLoading,
    startPolling: startPollingCompany,
    stopPolling: stopPollingCompany,
  } = useCurrentCompany();

  const startPolling = (): void => {
    startPollingSyncedProviders(1000);
    startPollingCompany(1000);
  };

  const stopPolling = (): void => {
    stopPollingSyncedProviders();
    stopPollingCompany();
  };

  const { accountingTokens, payrollTokens, ticketingTokens } = company || {};
  const { syncedProviders } = syncedProviderData?.getFiscalYear || {};

  return {
    accountingTokens,
    payrollTokens,
    ticketingTokens,
    syncedProviders,
    loading: syncedProvidersLoading || companyLoading,
    startPolling,
    stopPolling,
  };
};
